import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import './index.less';
import { useContext, useEffect, useState } from 'react';
import { CommonTabbarContext } from '@/App';
import { TAB_TYPE } from '@/enums/tab-type';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { Warning } from '@/global/interface/monitoring/warning';
import { useParams } from 'react-router-dom';
import { getWarnings } from '@/api/monitoring/warning';
import TnMessage from '@/global/components/message';
import { WARNING_LEVEL_DICT } from '@/enums/warning-level';


export default function WarningRecordPanel() {
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    const { projectId } = useParams();
    const [warnings, setWarnings] = useState<Warning[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        let addTab: TabRoute = {
            title: '报警记录详情',
            url: `${TAB_TYPE.WARNING}`,
            closable: true
        }
        commonTabbarContext.pushRoute(addTab)
    }, [])

    useEffect(() => {
        setLoading(true);
        getWarnings(+projectId).then(res => {
            if (res.status === 200) {
                let data: Warning[] = res.data || [];
                setWarnings(data);
            }
        }).catch(err => {
            TnMessage.error("获取报警信息失败");
        }).finally(() => {
            setLoading(false);
        })
    }, [])


    return (
        <div className='warning-record-container'>
            <div className='warning-record-table-area'>
                <Table
                    rowKey="id"
                    bordered={false}
                    loading={loading}
                    dataSource={warnings}
                    pagination={false}
                    sticky
                    className='tn-warning-table'
                >
                    <Table.Column title="报警时间" key="gmtCreate" dataIndex='gmtCreate' width="15%" ellipsis render={(v) => (
                        <div>{dayjs(v).format("YYYY-MM-DD HH:mm")}</div>
                    )} />
                    <Table.Column title="监测参数" key="parameterName" dataIndex='parameterName' ellipsis width="10%" />
                    <Table.Column title="监测对象/传感器" key="objectName" dataIndex='objectName' ellipsis width="20%" />
                    <Table.Column title="当前值" key="warningValue" dataIndex='warningValue' ellipsis width="10%" />
                    <Table.Column title="单位" key="unit" dataIndex='unit' width="15%" ellipsis />
                    <Table.Column title="报警原因" key="warningLevel" dataIndex='warningLevel' width="30%" ellipsis render={(v) => (
                        <span>{`超过${WARNING_LEVEL_DICT[v]}级预警值`}</span>
                    )} />
                </Table>
            </div>
        </div>
    )
}